import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { RadioCheckList } from 'ui-components/components/radio-check-list';
import { RadioCheckListItem } from 'ui-components/components/radio-check-list/radio-check-list-item';
import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';
import { useModalContext } from 'ui-components/components/modal/context';

import { AddressPropType } from '../../../../prop-types/address';
import { ValidationAddressSelection } from './validation-address-selection';
import style from '../style.module.less';
import { messages } from '../messages';

export const ValidationSelector = ({ addressResponse, setSelectSuggestedAddress, selectSuggestedAddress }) => {
  const { onClose } = useModalContext();
  const { matchedAddress, originalAddress } = addressResponse;

  const handleSelectSuggestedAddress = useCallback(() => {
    setSelectSuggestedAddress((prev) => !prev);
  }, [setSelectSuggestedAddress]);

  return (
    <>
      <Text className={style['modal-description']} textType={TextType.Description} value={messages.chooseAddressDescription} />
      <div className={style['validation-options']}>
        <RadioCheckList className={style.checklist}>
          <div className={style['radio-address']}>
            <RadioCheckListItem
              className={style['address-radio-button']}
              isChecked={!selectSuggestedAddress}
              onChecked={handleSelectSuggestedAddress}
            />
            <div className={style['original-address']}>
              <div className={style['label-and-radio']}>
                <Text textType={TextType.Label} value={messages.enteredAddress} />
                <ValidationAddressSelection address={originalAddress} />
              </div>
              <Button className={style['address-edit-button']} onClick={onClose} theme='link'>
                <FormattedMessage {...messages.editAddress} />
              </Button>
            </div>
          </div>
          <div className={style['radio-address']}>
            <RadioCheckListItem
              className={style['address-radio-button']}
              isChecked={selectSuggestedAddress}
              onChecked={handleSelectSuggestedAddress}
            />
            <div className={style['label-and-radio']}>
              <Text textType={TextType.Label} value={messages.suggestedAddress} />
              <ValidationAddressSelection address={matchedAddress} />
            </div>
          </div>
        </RadioCheckList>
      </div>
    </>
  );
};

ValidationSelector.propTypes = {
  addressResponse: PropTypes.shape({
    matchedAddress: AddressPropType.isRequired,
    originalAddress: AddressPropType.isRequired,
  }).isRequired,
  selectSuggestedAddress: PropTypes.bool.isRequired,
  setSelectSuggestedAddress: PropTypes.func.isRequired,
};
